import React, { useEffect, useState } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';

// Add this CSS to your stylesheet
const styles = `
.mdl-demo .dropdown-trigger {
  border-radius: 0.25rem;
  padding: 1rem 0.75rem;
  width: 100%;
  background-color: #fff;
  min-height: 58px;
}

.react-dropdown-tree-select .dropdown .dropdown-trigger {
    border: none !important;
    padding: 0;
}

.tag-item  {
    margin: 0px !important;
}

.tag-item .search {
    padding: 14px 0px 0px 0px;
}

.mdl-demo .dropdown-trigger.top-label {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.mdl-demo .tag-item {
  background-color: #e9ecef;
  border-radius: 0.25rem;
  padding: 2px 6px;
  margin: 2px;
  display: inline-block;
}

.mdl-demo .tag-remove {
  margin-left: 5px;
  cursor: pointer;
}

.form-floating > .tree-select {
  height: auto;
  min-height: 58px;
}

.form-floating > .tree-select ~ label {
  opacity: 0.65;
  transform: scale(.85) translateY(-0.5rem) translateX(0.15rem);
}

.react-dropdown-tree-select .dropdown .dropdown-content {
    max-height: 220px !important;
    border-radius: 0.75rem !important;
    transition: all 0.3s ease;
    }
`;

const MultiSelectDropdowns = ({ areaData, clinicData, onChange, errors = {}, resetSelections = false, selectedAreas: propSelectedAreas = [],
  selectedClinics: propSelectedClinics = [] }) => {

  // State to track selected values
  const [selectedAreas, setSelectedAreas] = useState(propSelectedAreas);
  const [selectedClinics, setSelectedClinics] = useState(propSelectedClinics);
  const areaError = errors?.areaSelect?.[0];
  const clinicError = errors?.clinicSelect?.[0];


  // Add useEffect to handle reset
  useEffect(() => {
    if (resetSelections) {
      setSelectedAreas([]);
      setSelectedClinics([]);
      setSelectedAreaLabels([]);
      setSelectedClinicLabels([]);

      // Also trigger onChange with empty values
      onChange({
        target: {
          name: 'areaSelect',
          value: [],
          labels: []
        }
      });

      onChange({
        target: {
          name: 'clinicSelect',
          value: [],
          labels: []
        }
      });
    }
  }, [resetSelections])

  // Sync selectedAreas from parent props
  useEffect(() => {
    setSelectedAreas(propSelectedAreas || []);
  }, [propSelectedAreas]);

  // Sync selectedClinics from parent props
  useEffect(() => {
    setSelectedClinics(propSelectedClinics || []);
  }, [propSelectedClinics]);


  // Transform area data into required format
  const transformAreaData = () => {
    const safeSelectedAreas = Array.isArray(selectedAreas) ? selectedAreas.map(Number) : [];

    return [
      {
        label: "Select All",
        value: "select_all",
        checked: safeSelectedAreas.length === areaData.length // optional
      },

      ...areaData.map(area => ({
        label: area.areaName,
        value: area.areaId,
        checked: safeSelectedAreas.includes(area.areaId)
      }))
    ]

  };

  // Transform clinic data into required format
  const transformClinicData = () => {
    // Ensure selectedClinics is always an array of numbers
    const safeSelectedClinics = Array.isArray(selectedClinics) ? selectedClinics.map(Number) : [];

    console.log('clinicData =>', clinicData);
    return [
      {
        label: "Select All",
        value: "select_all",
        checked: safeSelectedClinics.length === clinicData.length
      },
      ...clinicData.map(clinic => ({
        label: clinic.name,
        value: Number(clinic.clinicId),
        checked: safeSelectedClinics.includes(Number(clinic.clinicId))
      }))
    ];
  };

  const [areaTreeData, setAreaTreeData] = useState([]);
  const [clinicTreeData, setClinicTreeData] = useState([]);

  useEffect(() => {
    setAreaTreeData(transformAreaData());
  }, [areaData, selectedAreas]);

  useEffect(() => {
    setClinicTreeData(transformClinicData());
  }, [clinicData, selectedClinics]);

  const [selectedAreaLabels, setSelectedAreaLabels] = useState([]);
  const [selectedClinicLabels, setSelectedClinicLabels] = useState([]);

  useEffect(() => {
    setAreaTreeData(transformAreaData());
    setClinicTreeData(transformClinicData());
  }, [areaData, clinicData]);

  const handleAreaChange = (currentNode, selectedNodes) => {
    let newSelectedValues = selectedNodes.map(node => Number(node.value));

    if (currentNode.value === "select_all") {
      if (currentNode.checked) {
        // Select all real options
        newSelectedValues = areaData.map(area => Number(area.areaId));
      } else {
        // Deselect all
        newSelectedValues = [];
      }
    } else {
      // If all real options are manually selected, mark as all selected
      const allSelected = areaData.every(area => newSelectedValues.includes(Number(area.areaId)));
      newSelectedValues = allSelected ? [...newSelectedValues] : newSelectedValues.filter(v => v !== "select_all");
    }

    setSelectedAreas(newSelectedValues);

    // For display: only real labels, never show "Select All"
    const selectedLabels = areaData
      .filter(area => newSelectedValues.includes(Number(area.areaId)))
      .map(area => area.areaName);

    setSelectedAreaLabels(selectedLabels);

    onChange({
      target: {
        name: "areaSelect",
        value: newSelectedValues,
        labels: selectedLabels
      }
    });

    if (newSelectedValues.length > 0) delete errors.areaSelect;
  };



  const handleClinicChange = (currentNode, selectedNodes) => {
    let newSelectedValues = selectedNodes.map(node => Number(node.value)); // convert to numbers

    if (currentNode.value === "select_all") {
      if (currentNode.checked) {
        newSelectedValues = clinicData.map(clinic => Number(clinic.clinicId));
      } else {
        newSelectedValues = [];
      }
    } else {
      const allSelected = clinicData.every(clinic => newSelectedValues.includes(Number(clinic.clinicId)));
      newSelectedValues = allSelected ? [...newSelectedValues] : newSelectedValues.filter(v => v !== "select_all");
    }

    setSelectedClinics(newSelectedValues);

    const selectedLabels = clinicData
      .filter(clinic => newSelectedValues.includes(Number(clinic.clinicId)))
      .map(clinic => clinic.name);

    setSelectedClinicLabels(selectedLabels);

    onChange({
      target: {
        name: "clinicSelect",
        value: newSelectedValues,
        labels: selectedLabels
      }
    });

    if (newSelectedValues.length > 0) delete errors.clinicSelect;
  };



  const customAreaRenderer = ({ triggerHandler }) => (
    <div className="dropdown-trigger" onClick={triggerHandler}>
      <div className="comma-text">
        {selectedAreaLabels.length > 0 ? selectedAreaLabels.join(', ') : 'SELECT AREA'}
      </div>
    </div>
  );

  const customClinicRenderer = ({ triggerHandler }) => (
    <div className="dropdown-trigger" onClick={triggerHandler}>
      <div className="comma-text">
        {selectedClinicLabels.length > 0 ? selectedClinicLabels.join(', ') : 'SELECT CLINIC'}
      </div>
    </div>
  );

  console.log(selectedAreas)
  console.log(selectedClinics)

  return (
    <>
      <style>{styles}</style>
      <div className="clearfix"></div>
      <div className="col-md-6">
        <div className="form-floating mb-3">
          <div className="tree-select">
            <DropdownTreeSelect
              data={areaTreeData}
              onChange={handleAreaChange}
              className="form-control"
              texts={{ placeholder: `${selectedAreaLabels.length > 0 ? selectedAreaLabels.join(', ') : 'SELECT AREA'}` }}
              showPartiallySelected={true}
              keepTreeOnSearch={true}
              mode="multiSelect"
              renderer={{
                dropdown: customAreaRenderer
              }}
            />
          </div>
          <label className="form-label">Select Area</label>
          {areaError && <small className="text-danger">{areaError}</small>}
        </div>
      </div>

      <div className="clearfix"></div>
      <div className="col-md-6">
        <div className="form-floating mb-3">
          <div className="tree-select">
            <DropdownTreeSelect
              data={clinicTreeData}
              onChange={handleClinicChange}
              className="form-control"
              texts={{ placeholder: `${selectedClinicLabels.length > 0 ? selectedClinicLabels.join(', ') : 'SELECT CLINIC'}` }}
              showPartiallySelected={true}
              keepTreeOnSearch={true}
              mode="multiSelect"
              renderer={{
                dropdown: customClinicRenderer
              }}
            />
          </div>
          <label className="form-label">Select Clinic</label>
          {clinicError && <small className="text-danger">{clinicError}</small>}
        </div>
      </div>
    </>
  );
};

export default MultiSelectDropdowns;